import { useEffect, useRef, useState } from 'react';

const CLICK_GRACE_MS = 300;

function useCategoryFlyout(closeKey) {
  const [flyout, setFlyout] = useState(null);
  const openTimer = useRef(null);
  const closeTimer = useRef(null);
  const openedAt = useRef(0);

  const [prevCloseKey, setPrevCloseKey] = useState(closeKey);
  if (closeKey !== prevCloseKey) {
    setPrevCloseKey(closeKey);
    if (flyout) setFlyout(null);
  }

  useEffect(
    () => () => {
      clearTimeout(openTimer.current);
      clearTimeout(closeTimer.current);
    },
    [],
  );

  const openNow = (key, config, anchor) => {
    clearTimeout(openTimer.current);
    clearTimeout(closeTimer.current);
    openedAt.current = Date.now();
    setFlyout({ key, config, anchor });
  };

  const closeNow = () => {
    clearTimeout(openTimer.current);
    setFlyout(null);
  };

  const cancelClose = () => {
    clearTimeout(closeTimer.current);
  };

  const handleMouseEnter = (key, config, event) => {
    const anchor = event.currentTarget;

    clearTimeout(closeTimer.current);
    clearTimeout(openTimer.current);
    openTimer.current = setTimeout(() => openNow(key, config, anchor), 150);
  };

  const handleMouseLeave = () => {
    clearTimeout(openTimer.current);
    closeTimer.current = setTimeout(closeNow, 175);
  };

  const handleClick = (key, config, event) => {
    if (flyout?.key === key) {
      if (Date.now() - openedAt.current < CLICK_GRACE_MS) return;
      closeNow();
      return;
    }
    openNow(key, config, event.currentTarget);
  };

  const handleKeyDown = (key, config, event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    handleClick(key, config, event);
  };

  return {
    flyout,
    closeNow,
    cancelClose,
    handleMouseEnter,
    handleMouseLeave,
    handleClick,
    handleKeyDown,
  };
}

export default useCategoryFlyout;
